<template>
  <div>

      <Banner></Banner>

      <BrandsLogos></BrandsLogos>

      <About></About>

      <Vistion></Vistion>

      <WhyChooseUs></WhyChooseUs>

      <TypeDiv></TypeDiv>

      <Portfolio></Portfolio>

      <Const></Const>

  </div>
</template>

<script>
import Banner from '../../components/WebDevelopment/CodeigniterDevelopment/Banner.vue'
import Vistion from '../../components/WebDevelopment/CodeigniterDevelopment/Vistion.vue'
import WhyChooseUs from '../../components/WebDevelopment/CodeigniterDevelopment/WhyChooseUs.vue'
import BrandsLogos from '../../components/AssetComponents/BrandsLogos.vue'
import Portfolio from '../../components/Home/Portfolio.vue'
import About from '../../components/WebDevelopment/CodeigniterDevelopment/About.vue'
import TypeDiv from '../../components/Home/TypeDiv.vue'
import Const from '../../components/AssetComponents/Const.vue'

export default {
    components:{
        Banner,
        BrandsLogos,
        About,
        TypeDiv,
        WhyChooseUs,
        Portfolio,
        Const,
        Vistion,
    }
}
</script>


<style>

</style>